export const GET_COUNTRIES_START = "GET_COUNTRIES_START";
export const GET_COUNTRIES_FINISH = "GET_COUNTRIES_FINISH";
export const GET_COUNTRIES_ERROR = "GET_COUNTRIES_ERROR";
